import { FunctionComponent } from "react";
import { Button, Drawer, FloatButton } from "antd";
import { ReloadOutlined, RobotOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { ChatbotPanel } from "./ChatbotPanel";
import { useChatbotStore } from "../stores/useChatbotStore";

export const ChatbotWidget: FunctionComponent = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const open = useChatbotStore((state) => state.open);
    const setOpen = useChatbotStore((state) => state.setOpen);
    const messagesCount = useChatbotStore((state) => state.messages.length);
    const resetConversation = useChatbotStore((state) => state.reset);

    return (
        <>
            {!open && (
                // Sur desktop le bouton porte son libellé : une icône seule n'est explicite
                // qu'au survol, donc invisible pour qui ne l'a jamais ouvert. Sur mobile on
                // garde le cercle (le bouton carré empiéterait sur le contenu) — la
                // découvrabilité y passe par le raccourci de la barre supérieure.
                <FloatButton
                    type="primary"
                    className="chatbot-float-button"
                    shape={isMobile ? "circle" : "square"}
                    icon={<RobotOutlined />}
                    description={isMobile ? undefined : "Assistant"}
                    tooltip={isMobile ? "Besoin d'aide ? Ouvrir l'assistant" : undefined}
                    aria-label="Ouvrir l'assistant"
                    onClick={() => setOpen(true)}
                />
            )}
            <Drawer
                title="Assistant"
                placement="right"
                width={isMobile ? "100%" : 420}
                open={open}
                onClose={() => setOpen(false)}
                extra={
                    messagesCount > 0 ? (
                        <Button
                            type="text"
                            size="small"
                            icon={<ReloadOutlined />}
                            onClick={resetConversation}
                            aria-label="Démarrer une nouvelle conversation"
                        >
                            Nouvelle conversation
                        </Button>
                    ) : undefined
                }
                styles={{ body: { padding: 0, display: "flex", flexDirection: "column" } }}
            >
                <ChatbotPanel />
            </Drawer>
        </>
    );
};
